import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import { listItemVariants } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuRadioItemProps extends PartProps<BaseContextMenu.RadioItem.Props> {
  className?: string
}

function ContextMenuRadioItem({ className, children, ...props }: ContextMenuRadioItemProps) {
  return (
    <BaseContextMenu.RadioItem data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {children}
    </BaseContextMenu.RadioItem>
  )
}

export { ContextMenuRadioItem }
